import React from "react"
import moment from "moment"

const COLOR_ACTIVITIES = "rgba(255, 0, 0, 0.3)"

const TableLavorazioniOrdine = ({ lavorazioniOrdine, totals }) => {
  return (
    <table className="table table-bordered table-hover table-striped mt-2">
      <thead>
        <tr>
          <td colSpan="7" align="right"></td>
          <td>
            <div className="badge badge-primary">
              {
                totals.unita_tot ? totals.unita_tot : 0
              }
            </div>
          </td>
          <td>
            <div className="badge badge-primary">
              {parseInt(
                moment.duration(totals.tempo_teorico_tot).as("minutes")
              ) + " min"}
            </div>
          </td>
          <td>
            <div className="badge badge-primary">
              {parseInt(moment.duration(totals.tempo_tot).as("minutes")) +
                " min"}
            </div>
          </td>
        </tr>
        <tr>
          <th>Ordine</th>
          <th>Lavorazione</th>
          <th>Operatore</th>
          <th>Data inizio</th>
          <th>Data fine</th>
          <th>Unità</th>
          <th>Tempo unitario</th>
          <th>Somma unità</th>
          <th>Tempo teorico</th>
          <th>Tempo</th>
        </tr>
      </thead>
      <tbody>
        {lavorazioniOrdine.map((lavorazione) => (
          <tr
            style={{
              background:
                lavorazione.tempo_teorico < lavorazione.tempo
                  ? COLOR_ACTIVITIES
                  : "",
            }}
            key={`${lavorazione.ordine}-${lavorazione.operatore}-${lavorazione.lavorazione}`}
          >
            <td className="text-nowrap">
              {lavorazione.ordine_numero_commessa} -{" "}
              {lavorazione.ordine_nome_cliente}
            </td>
            <td>{lavorazione.lavorazione_nome}</td>
            <td className="text-nowrap">
              {lavorazione.operatore_fist_name}{" "}
              {lavorazione.operatore_last_name}
            </td>
            <td className="text-nowrap">
              {moment(lavorazione.data_inizio).format("DD-MM-YYYY")}
            </td>
            <td className="text-nowrap">
              {moment(lavorazione.data_fine).format("DD-MM-YYYY")}
            </td>
            <td>{lavorazione.tempo_teorico_unita}</td>
            <td className="text-nowrap">
              {lavorazione.tempo_teorico_unitario
                ? parseInt(
                    moment
                      .duration(lavorazione.tempo_teorico_unitario)
                      .as("minutes")
                  ) + " min"
                : ""}
            </td>
            <td>{lavorazione.tempo_teorico_size}</td>
            <td className="text-nowrap">
              {lavorazione.tempo_teorico
                ? parseInt(
                    moment.duration(lavorazione.tempo_teorico).as("minutes")
                  ) + " min"
                : ""}
            </td>
            <td className="text-nowrap">
              {lavorazione.tempo
                ? parseInt(moment.duration(lavorazione.tempo).as("minutes")) +
                  " min"
                : ""}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default TableLavorazioniOrdine
